export class Option {
  id: number;

  code: string;
  next_charge_at: Date;

  activated: Boolean;
  activation_date: Date;

  amount: number;
  is_running: boolean;

  created_at: Date;
  updated_at: Date;

  subscription_id: number;
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/entities/option.entity.ts